import React, { ChangeEvent } from 'react';
import { ArrowRightAlt, CheckCircle, DeleteOutline } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Avatar, InputAdornment, TextField } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { AssignmentQuestionAnswer } from '../../../state/assignment-edit.types';
import colors from '../../../../../../../styles/colors';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    fontSize: '1.8rem',
    marginRight: '10px',
    cursor: 'pointer',
    color: (props: { isCorrect: boolean }) =>
      props.isCorrect ? '#16A32C' : '#D7D7D7'
  },
  avatar: {
    marginRight: '10px',
    cursor: 'pointer',
    width: theme.spacing(4),
    height: theme.spacing(4)
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${colors.assignment.grey}`,
    padding: '2px 6px',
    paddingRight: '2px',
    fontSize: 16,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)'
    }
  },
  underline: {
    '&&&:before': {
      borderBottom: 'none'
    },
    '&&:after': {
      borderBottom: 'none'
    }
  }
}));

interface AnswerOptionProps {
  answer: AssignmentQuestionAnswer;
  handleAnswerUpdate(answerId: string, data: object): any;
  handleDeleteAnswer(answerId: string): any;
  isOrdered: boolean;
  isPair: boolean;
  number: number;
}

const AnswerOption: React.FC<AnswerOptionProps> = (
  props: AnswerOptionProps
) => {
  const {
    answer,
    handleDeleteAnswer,
    handleAnswerUpdate,
    isOrdered,
    isPair,
    number
  } = props;
  const classes = useStyles({
    isCorrect: answer.isCorrect
  });

  const handleAnswer = (evt: ChangeEvent<HTMLInputElement>) => {
    handleAnswerUpdate(answer.id, { text: evt.target.value });
  };
 
  const handlePair = (evt: ChangeEvent<HTMLInputElement>) => {
    handleAnswerUpdate(answer.id, { pair: evt.target.value });
  };

  return (
    <Grid container spacing={2}> 
      <Grid item xs={12} className={classes.root}>
        {isOrdered && (
          <Avatar className={classes.avatar} sizes={'sm'}>
            {number}
          </Avatar>
        )}
        {isPair && (
          <>
          <TextField
            name={'text'}
            fullWidth={true}
            value={answer.text}
            onChange={handleAnswer}
            InputProps={{
              className: `${classes.input} ${classes.underline}`,
            }}
            style={{marginRight:'30px'}}
          />
          <ArrowRightAlt fontSize='large' />
          <TextField
            name={'pair'}
            fullWidth={true}
            value={answer.pair}
            onChange={handlePair}
            InputProps={{
              className: `${classes.input} ${classes.underline}`,
            }}
            style={{marginLeft:'30px'}}
          />
          <IconButton
              aria-label="delete answer"
              onClick={() => handleDeleteAnswer(answer.id)}
            >
              <DeleteOutline />
            </IconButton>
          </>
        )}
        {!isOrdered && !isPair && (
          <CheckCircle
            onClick={() =>
              handleAnswerUpdate(answer.id, { isCorrect: !answer.isCorrect })
            }
            className={classes.icon}
          />
        )
        }

        {!isPair &&
          <TextField
            name={'text'}
            fullWidth={true}
            value={answer.text}
            onChange={handleAnswer}
            InputProps={{
              className: `${classes.input} ${classes.underline}`,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="delete answer"
                    onClick={() => handleDeleteAnswer(answer.id)}
                  >
                    <DeleteOutline />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />}
      </Grid>
    </Grid>
  );
};

export default AnswerOption;
